import { useQuery } from 'react-query';

import { QueryEntity } from '../types';
import { User } from '../types/backend-dto-types';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig from '@/api/useGetFetchConfig';

const useGetUser = () => {
  const { fetchConfigGET } = useGetFetchConfig();

  const getUser = async (): Promise<User> => {
    const response = await fetch(`${APIBaseChronos}/api/user`, fetchConfigGET);

    return response.json();
  };

  return useQuery([QueryEntity.User], getUser, { refetchOnWindowFocus: false });
};

export default useGetUser;
